"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestFilterSelector = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var useFilterOptionStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    filterOptionWrapper: {
        background: "none",
        border: "none",
        borderBottom: "2px solid ".concat(function (_a) {
            var isSelected = _a.isSelected;
            return (isSelected ? theme.colors.primary : "transparent");
        }),
        boxSizing: "border-box",
        color: function (_a) {
            var isSelected = _a.isSelected;
            return isSelected ? theme.colors.baseContrast100 : theme.colors.primary;
        },
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "10px",
        margin: "0 8px",
        padding: "".concat(theme.spacing.base, "px 0"),
    },
}); });
var useContestFilterSelectorStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    filterSelectorWrapper: {
        alignItems: "center",
        display: "flex",
        height: "32px",
    },
    filtersLabel: {
        fontSize: "14px",
        // eslint-disable-next-line @atg/css-rtl-support
        marginRight: theme.spacing.base,
    },
}); });
var FilterOption = function (_a) {
    var isSelected = _a.isSelected, label = _a.label, onClick = _a.onClick;
    var classes = useFilterOptionStyles({ isSelected: isSelected });
    return (React.createElement("div", { className: classes.filterOptionWrapper, "data-ta-locator": "contest_filter_option", onClick: onClick }, label));
};
var filterOptions = [
    { stringKey: "contest.available", value: "available" },
    { stringKey: "contest.full_ranking", value: "all" },
];
var ContestFilterSelector = function (props) {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext), 1), translate = _a[0].translate;
    var classes = useContestFilterSelectorStyles();
    return (React.createElement("div", { className: classes.filterSelectorWrapper },
        React.createElement("div", { className: classes.filtersLabel }, "".concat(translate("contest.filter"), ":")),
        filterOptions.map(function (option) { return (React.createElement(FilterOption, { label: translate(option.stringKey), key: option.stringKey, isSelected: props.contestFilter === option.value, onClick: function () {
                props.emitTrackingEvent("icfClick", "contestFilter", "label=".concat(option.value));
                if (props.contestFilter !== option.value) {
                    props.onContestFilterChange(option.value);
                }
            } })); })));
};
exports.ContestFilterSelector = ContestFilterSelector;
//# sourceMappingURL=ContestFilterSelector.js.map